import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SIDEBAR_LIST } from "../../data/constants";
import {
  handelEndMonth,
  handelStartMonth,
  handleSelectedMonths,
  handleToggleSidebar,
} from "../../data/slices/layout";
import { generateMonthList } from "../../utilities/filters";
import { Header, Toggle } from "./components/Header";
import NavButton from "./components/NavButton";
import Settings from "./components/Settings";
import { openListObjectiveDialog } from "../../data/slices/objectives";
import { useLocation } from "react-router-dom";
import { setMonthList } from "../../data/slices/categories";
import { useFiltersAndDates } from "../../hooks/useFiltersAndDate";

const Sidebar = () => {
  const dispatch = useDispatch();
  const { mode, objectif, isSidebarClosed } = useSelector(
    (state) => state.layout
  );
  const { getStartAndEndDateSideBar } = useFiltersAndDates();

  const location = useLocation();
  const currentURL = location?.pathname;
  const isListing = currentURL.includes("listing");

  const handleItemClick = (item) => {
    if (location.pathname.includes("listing")) return;

    if (item === "Afficher un budget prev." && mode === "compta") {
      dispatch(openListObjectiveDialog({ status: "true" }));
    }
  };

  const handleClickToggleSidebar = () => {
    dispatch(handleToggleSidebar(!isSidebarClosed));
  };

  const { start, end } = getStartAndEndDateSideBar();

  const handleMonthChange = useCallback(
    (dates) => {
      if (dates && dates?.length === 2) {
        dispatch(handelStartMonth(dates[0]));
        dispatch(handelEndMonth(dates[1]));
        dispatch(handleSelectedMonths(generateMonthList(dates[0], dates[1])));
        dispatch(setMonthList(generateMonthList(dates[0], dates[1])));
      }
    },
    [dispatch]
  );

  return (
    <div className="sidebar">
      <div className={`sidebar-wrapper ${isSidebarClosed && "sidebar-closed"}`}>
        <div
          className={`sidebar ${
            mode === "compta" || currentURL.includes("compta-plan")
              ? "blue"
              : " yellow"
          } ${isSidebarClosed && "sidebar-closed"}`}
        >
          <Header
            isSidebarClosed={isSidebarClosed}
            className={"sidebar_header"}
          />
          {SIDEBAR_LIST?.map((item, i) => {
            const isGraphPage = currentURL.includes("graph");

            const itemsToHideOnGraphPage = [0, 3, 4];
            const itemsToHideOnComptaPlanPage = [0];

            const shouldDisplayItem =
              !isGraphPage ||
              !itemsToHideOnComptaPlanPage.includes(item?.id) ||
              (isGraphPage && !itemsToHideOnGraphPage.includes(item?.id));

            let disabled = false;

            if (item.name === "Afficher un budget prev.") {
              disabled =
                mode === "treso" || objectif || isGraphPage || isListing;
            }

            return shouldDisplayItem ? (
              <>
                <NavButton
                  mode={currentURL.includes("compta-plan") ? "compta" : mode}
                  handleMonthChange={handleMonthChange}
                  selectedMonthRange={[start, end]}
                  onClick={handleItemClick}
                  name={item?.name}
                  icon={item.icon}
                  label={item.label}
                  arrowIcon={item.arrowIcon}
                  hasDivider={item.hasDivider}
                  isDatePicker={item.isDatePicker}
                  isNavButton={item.navButton}
                  isSwitch={item?.isSwitch}
                  background={item.background}
                  route={item.route}
                  key={item?.id}
                  subItems={item?.items}
                  isPopover={item?.isPopover}
                  disabled={disabled}
                />
              </>
            ) : (
              <>
                <div style={{ visibility: "hidden" }}>
                  <NavButton name={item.name} isNavButton={item.navButton} />
                </div>
              </>
            );
          })}
          <Settings />
        </div>
        <Toggle
          onClick={handleClickToggleSidebar}
          isClosed={isSidebarClosed}
          mode={mode}
        />
      </div>
    </div>
  );
};

export default Sidebar;
